kombi.carousel = function (root) {
    const scope = root && root.querySelector ? root : document;
    const carousel =
        scope.id === "hotelCarousel"
            ? scope
            : scope.querySelector("#hotelCarousel");

    if (!carousel) {
        return;
    }
    if (kombi.lifecycle.isInitialized(carousel, "hotel-carousel")) {
        return;
    }
    kombi.lifecycle.markInitialized(carousel, "hotel-carousel");

    function deferHotelCarouselAutoplay(carouselEl) {
        if (!carouselEl || !window.bootstrap || !bootstrap.Carousel) {
            return;
        }
        if (carouselEl.querySelectorAll(".carousel-item").length < 2) {
            return;
        }

        function startCycle() {
            bootstrap.Carousel.getOrCreateInstance(carouselEl).cycle();
        }

        function onIdle(callback) {
            if (typeof window.requestIdleCallback === "function") {
                window.requestIdleCallback(callback, { timeout: 4000 });
            } else {
                window.setTimeout(callback, 1);
            }
        }

        if (document.readyState === "complete") {
            onIdle(startCycle);
        } else {
            window.addEventListener(
                "load",
                function () {
                    onIdle(startCycle);
                },
                { once: true }
            );
        }
    }

    function parseSlideIndex(value, fallback) {
        const parsed = Number(value);
        return Number.isInteger(parsed) ? parsed : fallback;
    }

    deferHotelCarouselAutoplay(carousel);

    const thumbTrack = carousel.querySelector(".carousel-indicators");
    if (!thumbTrack) {
        return;
    }

    const indicators = Array.from(thumbTrack.querySelectorAll("img[data-bs-slide-to]"));
    const geometry = {
        sliderWidth: 0,
        maxScroll: 0,
        thumbCenters: [],
    };
    const RELEASE_EVENTS = ["pointerup", "pointercancel"];

    function readGeometry() {
        geometry.sliderWidth = thumbTrack.clientWidth;
        geometry.maxScroll = Math.max(0, thumbTrack.scrollWidth - thumbTrack.clientWidth);
        geometry.thumbCenters = indicators.map(function (thumb) {
            return thumb.offsetLeft + thumb.offsetWidth / 2;
        });
    }

    function scrollThumbIntoView(index) {
        const center = geometry.thumbCenters[index];
        if (center == null) {
            return;
        }
        thumbTrack.scrollLeft = Math.min(
            geometry.maxScroll,
            Math.max(0, center - geometry.sliderWidth / 2)
        );
    }

    function setActiveThumb(fromIndex, toIndex) {
        const prev = indicators[fromIndex];
        const next = indicators[toIndex];
        if (prev && prev !== next) {
            prev.classList.remove("active");
            prev.removeAttribute("aria-current");
        }
        if (next) {
            next.classList.add("active");
            next.setAttribute("aria-current", "true");
        }
        scrollThumbIntoView(toIndex);
    }

    function bindTrackDrag() {
        let isPointerDown = false;
        let isDragging = false;
        let startX = 0;
        let startScroll = 0;
        let pendingX = 0;
        let scrollFrameId = 0;
        let suppressClick = false;
        const DRAG_SPEED = 3;
        const DRAG_THRESHOLD = 8;

        function applyScroll() {
            scrollFrameId = 0;
            if (!isDragging) {
                return;
            }
            thumbTrack.scrollLeft = startScroll - (pendingX - startX) * DRAG_SPEED;
        }

        function setDocumentRelease(enabled) {
            const method = enabled ? "addEventListener" : "removeEventListener";
            RELEASE_EVENTS.forEach(function (name) {
                document[method](name, endDrag);
            });
        }

        function onPointerDown(event) {
            if (event.pointerType !== "mouse" || event.button !== 0) {
                return;
            }
            isPointerDown = true;
            isDragging = false;
            suppressClick = false;
            startX = event.clientX;
            pendingX = startX;
            startScroll = thumbTrack.scrollLeft;
            setDocumentRelease(true);
        }

        function onPointerMove(event) {
            if (!isPointerDown) {
                return;
            }
            if (event.buttons === 0) {
                endDrag(event);
                return;
            }
            pendingX = event.clientX;
            if (!isDragging) {
                if (Math.abs(pendingX - startX) <= DRAG_THRESHOLD) {
                    return;
                }
                isDragging = true;
                if (thumbTrack.setPointerCapture) {
                    thumbTrack.setPointerCapture(event.pointerId);
                }
            }
            event.preventDefault();
            if (!scrollFrameId) {
                scrollFrameId = window.requestAnimationFrame(applyScroll);
            }
        }

        function endDrag(event) {
            if (!isPointerDown) {
                return;
            }
            isPointerDown = false;
            setDocumentRelease(false);
            if (isDragging) {
                suppressClick = true;
                if (scrollFrameId) {
                    window.cancelAnimationFrame(scrollFrameId);
                    applyScroll();
                }
                if (
                    event &&
                    thumbTrack.releasePointerCapture &&
                    thumbTrack.hasPointerCapture &&
                    thumbTrack.hasPointerCapture(event.pointerId)
                ) {
                    thumbTrack.releasePointerCapture(event.pointerId);
                }
            }
            isDragging = false;
        }

        thumbTrack.addEventListener("pointerdown", onPointerDown);
        thumbTrack.addEventListener("pointermove", onPointerMove);
        thumbTrack.addEventListener(
            "click",
            function (event) {
                if (!suppressClick) {
                    return;
                }
                suppressClick = false;
                event.preventDefault();
                event.stopPropagation();
            },
            true
        );
    }

    if (typeof ResizeObserver === "function") {
        new ResizeObserver(readGeometry).observe(thumbTrack);
    }

    bindTrackDrag();
    readGeometry();

    carousel.addEventListener("slid.bs.carousel", function (event) {
        const nextIndex = parseSlideIndex(event.to, 0);
        const prevIndex = parseSlideIndex(event.from, 0);
        if (!geometry.thumbCenters.length) {
            readGeometry();
        }
        setActiveThumb(prevIndex, nextIndex);
    });
};
